import {CollectionViewer, DataSource} from "@angular/cdk/collections";

import { Observable, BehaviorSubject, of } from "rxjs";
import { catchError, finalize } from 'rxjs/operators';
import { DeliveryConfirmDto, DeliveryConfirmServiceProxy } from "../../shared/service-proxies/service-proxies";

export class DeliveryConfirmDataSource implements DataSource<DeliveryConfirmDto> {

    public deliverySubject = new BehaviorSubject<DeliveryConfirmDto[]>([]);
    private loadinSubject = new BehaviorSubject<boolean>(false);
    private hasItemsSubject = new BehaviorSubject<boolean>(null);


    private teslimAlinan = new BehaviorSubject<number>(null)

    public rowGuids = []
    public loading$ = this.loadinSubject.asObservable();
    public hasItems$ = this.hasItemsSubject.asObservable();
    public teslimAlinanAdet = this.teslimAlinan.asObservable()

    constructor (
        private _deliveryConfirmService : DeliveryConfirmServiceProxy
    ){

    }

    connect(collectionViewer: CollectionViewer): Observable<DeliveryConfirmDto[]> {
        return this.deliverySubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.deliverySubject.complete();
        this.loadinSubject.complete();
        this.hasItemsSubject.complete();
    }

    /**
     * confirm edilmesi gereken urun teslimatlarini listeler.
     * @param cariHareketId GUID
     */
    loadDeliveries(cariHareketId: string){
        //Loading basliyor...
        this.loadinSubject.next(true);
        this.hasItemsSubject.next(true)

        this._deliveryConfirmService.getDeliveryConfirmForApprove(cariHareketId)
        .subscribe(
            deliveries => 
          
            {
                this.deliverySubject.next(deliveries), 
                console.log('deliveries', deliveries)
                deliveries.forEach(x=>{
                    this.rowGuids.push(x.rowGuid)

                })

                if(deliveries.length == 0){
                    this.hasItemsSubject.next(false)
                }
                
            
            },

            (err) => {
                console.log('err', err)
            }, //Error
            () => {      //OnComplete
                console.log('complete', this.rowGuids)
                
                this.loadinSubject.next(false);
            }

            
        )
    }

    
   

}
